module.exports = __webpack_public_path__ + "img/login-banner.fd0850a8.jpg";